import React from "react";
import Navbar from "../component/includes/navbar";
import Footer from "../component/includes/footer";
import HeroBanner from "../component/includes/banner";
import ServiceGrid from "../component/includes/card/Layanan";
import ProductPage from "../component/includes/product";
import Detection from "../component/includes/detaction";
import NewsGrid from "../component/includes/card/berita";
import Gallery from "../component/includes/gallery";
import Galleryvideo from "../component/includes/video";

function Home() {
  return (
    <div className="flex flex-col min-h-screen mesh-bg font-sans">
      <Navbar />
      <main className="flex-grow">
        {/* Hero Banner Section */}
        <HeroBanner />

        {/* Main Content Container */}
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* Produk Wisata Kesehatan Jamu Section */}
          <section className="py-12 sm:py-16 animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
            <div className="glass-card p-6 sm:p-10">
              <div className="text-center mb-10">
                <h2 className="text-3xl sm:text-4xl font-extrabold gradient-text tracking-tight pb-2">
                  Produk Wisata Kesehatan Jamu
                </h2>
                <p className="mt-3 text-base sm:text-lg text-gray-600 font-medium">
                  Temukan produk herbal terbaik untuk kesehatan Anda
                </p>
              </div>
              <div className="relative">
                <ProductPage showSearchAndFilter={true} limit={6} />
              </div>
            </div>
          </section>

          {/* Identifikasi Tanaman Section */}
          <section className="py-12 sm:py-16 animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            <div className="glass-card p-6 sm:p-10">
              <div className="text-center mb-10">
                <h2 className="text-3xl sm:text-4xl font-extrabold gradient-text tracking-tight pb-2">
                  Identifikasi Tanaman
                </h2>
                <p className="mt-3 text-base sm:text-lg text-gray-600 font-medium">
                  Deteksi dan kenali tanaman herbal Anda dengan teknologi AI
                </p>
              </div>
              <Detection />
            </div>
          </section>

          {/* Gallery Section */}
          <section className="py-12 sm:py-16 animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
            <div className="glass-card p-6 sm:p-10">
              <div className="text-center mb-10">
                <h2 className="text-3xl sm:text-4xl font-extrabold gradient-text tracking-tight pb-2">
                  Galeri Wisata Kesehatan
                </h2>
                <p className="mt-3 text-base sm:text-lg text-gray-600 font-medium">
                  Jelajahi koleksi momen indah dari destinasi wisata kesehatan kami
                </p>
              </div>
              <Gallery />
            </div>
          </section>

          {/* Video Gallery Section */}
          <section className="py-12 sm:py-16 animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
            <div className="glass-card p-6 sm:p-10 bg-gradient-to-br from-white/80 to-white/40">
              <div className="text-center mb-10">
                <h2 className="text-3xl sm:text-4xl font-extrabold gradient-text tracking-tight pb-2">
                  Video Galeri Wisata Kesehatan
                </h2>
                <p className="mt-3 text-base sm:text-lg text-gray-600 font-medium">
                  Tonton pengalaman imersif tentang wisata kesehatan kami
                </p>
              </div>
              <Galleryvideo />
            </div>
          </section>

          {/* Layanan Wisata Kesehatan Jamu Section */}
          <section className="py-12 sm:py-16 animate-fade-in-up" style={{ animationDelay: '0.5s' }}>
            <div className="glass-card p-6 sm:p-10 border-t-4 border-t-emerald-500">
              <div className="text-center mb-10">
                <h2 className="text-3xl sm:text-4xl font-extrabold gradient-text tracking-tight pb-2">
                  Layanan Unggulan Kami
                </h2>
                <p className="mt-3 text-base sm:text-lg text-gray-600 font-medium">
                  Beragam pelayanan holistik terbaik untuk menunjang kesehatan Anda
                </p>
              </div>
              <ServiceGrid />
            </div>
          </section>

          {/* Berita Terkait Section */}
          <section className="py-12 sm:py-16 animate-fade-in-up" style={{ animationDelay: '0.6s' }}>
            <div className="glass-card p-6 sm:p-10">
              <div className="text-center mb-10">
                <h2 className="text-3xl sm:text-4xl font-extrabold gradient-text tracking-tight pb-2">
                  Berita & Informasi Terkini
                </h2>
                <p className="mt-3 text-base sm:text-lg text-gray-600 font-medium">
                  Dapatkan wawasan dan kabar terbaru seputar dunia kesehatan
                </p>
              </div>
              <NewsGrid isHomePage={true} />
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default Home;